import { put, call, takeLatest } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneCustomContentType,
  GET_ONE_CUSTOM_CONTENT_TYPE,
  GET_ONE_CUSTOM_CONTENT_TYPE_ERROR,
  GET_ONE_CUSTOM_CONTENT_TYPE_SUCCESS,
} from '../types/custom-content-tye/get-one'

import {
  GetAllCustomContentTypes,
  GET_ALL_CUSTOM_CONTENT_TYPES,
  GET_ALL_CUSTOM_CONTENT_TYPES_ERROR,
  GET_ALL_CUSTOM_CONTENT_TYPES_SUCCESS,
} from '../types/custom-content-tye/get-all'

import {
  NewCustomContentType,
  NEW_CUSTOM_CONTENT_TYPE,
  NEW_CUSTOM_CONTENT_TYPE_ERROR,
  NEW_CUSTOM_CONTENT_TYPE_SUCCESS,
} from '../types/custom-content-tye/new'

import {
  EditCustomContentType,
  EDIT_CUSTOM_CONTENT_TYPE,
  EDIT_CUSTOM_CONTENT_TYPE_ERROR,
  EDIT_CUSTOM_CONTENT_TYPE_SUCCESS,
} from '../types/custom-content-tye/edit'

import {
  DeleteCustomContentType,
  DELETE_CUSTOM_CONTENT_TYPE,
  DELETE_CUSTOM_CONTENT_TYPE_ERROR,
  DELETE_CUSTOM_CONTENT_TYPE_SUCCESS,
} from '../types/custom-content-tye/delete'

function* getOneCustomContentType({ payload }) {
  try {
    const { response, error } = yield call(services.content.getOne, payload)
    if (error) {
      yield put({
        type: GET_ONE_CUSTOM_CONTENT_TYPE_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_CUSTOM_CONTENT_TYPE_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_CUSTOM_CONTENT_TYPE_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* getAllCustomContentTypes({ payload }) {
  try {
    const { response, error } = yield call(services.content.getAll, {
      ...payload,
      filters: { 'content-type': 'custom-type' },
    })
    if (error) {
      yield put({
        type: GET_ALL_CUSTOM_CONTENT_TYPES_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_CUSTOM_CONTENT_TYPES_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_CUSTOM_CONTENT_TYPES_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* newCustomContentType({ payload }) {
  try {
    const { response, error } = yield call(services.content.new, payload)
    if (error) {
      yield put({
        type: NEW_CUSTOM_CONTENT_TYPE_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: NEW_CUSTOM_CONTENT_TYPE_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: NEW_CUSTOM_CONTENT_TYPE_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* editCustomContentType({ payload }) {
  try {
    const { response, error } = yield call(services.content.edit, payload)
    if (error) {
      yield put({
        type: EDIT_CUSTOM_CONTENT_TYPE_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: EDIT_CUSTOM_CONTENT_TYPE_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: EDIT_CUSTOM_CONTENT_TYPE_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* deleteCustomContentType({ payload }) {
  try {
    const { response, error } = yield call(services.content.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_CUSTOM_CONTENT_TYPE_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: DELETE_CUSTOM_CONTENT_TYPE_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: DELETE_CUSTOM_CONTENT_TYPE_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneCustomContentType>(GET_ONE_CUSTOM_CONTENT_TYPE, getOneCustomContentType)
  yield takeLatest<GetAllCustomContentTypes>(GET_ALL_CUSTOM_CONTENT_TYPES, getAllCustomContentTypes)
  yield takeLatest<NewCustomContentType>(NEW_CUSTOM_CONTENT_TYPE, newCustomContentType)
  yield takeLatest<EditCustomContentType>(EDIT_CUSTOM_CONTENT_TYPE, editCustomContentType)
  yield takeLatest<DeleteCustomContentType>(DELETE_CUSTOM_CONTENT_TYPE, deleteCustomContentType)
}
